import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label, Input} from 'reactstrap';

class SelectFormGroup extends React.Component {
    static propTypes = {
        label: PropTypes.element,
        values: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
        valueSelected: PropTypes.string,
        setValue: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(event) {
        const value = event.target.value;
        this.props.setValue(value);
    }

    render() {
        const {name, id, label, values, valueSelected} = this.props;

        const value = valueSelected ? valueSelected : '';

        return (
            <FormGroup>
                {typeof label !== "undefined" &&
                <Label for={id}>
                    {label}
                </Label>
                }

                <Input name={name} id={id} type="select" value={value} onChange={this.changeValue}>
                    {values.map((item, idx) => (
                        <option value={item.value} key={idx}>{item.name}</option>
                    ))}
                </Input>
            </FormGroup>
        )
    }
}

export default SelectFormGroup;


// WEBPACK FOOTER //
// ./src/components/NonFormsyForm/SelectFormGroup.jsx